export interface TwoFactorAuthResponse {
  enabled: boolean;
  secret: string;
  scratchCodes: number[];
}
